import FormErrors from "@/components/FormErrors/FormErrors";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";
import uuidv4 from "uuid/v4";
import { JSConn } from "@/utilities/js-conn";
import { dissoc as Rdissoc } from "ramda";

export default {
  name: "userEditForm",
  components: {
    FormErrors,
    LoadingAnimation,
  },
  props: {
    userId: String,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading User...",
      hasFormErrors: false,
      cancelParams: { name: "users" },
      formErrors: [],
      user: {
        id: null,
        name: null,
        password: null,
        email: null,
        status: "active",
      },
    };
  },
  created() {
    if (this.userId === "new") {
      this.user = {
        id: uuidv4(),
        name: "New",
        email: "",
        status: "active",
        permission_level: "field_worker",
        password: "",
      };
      this.dataLoaded = true;
      this.$nextTick(() => this.$refs.firstInput.select());
    } else {
      const jsConn = new JSConn();

      jsConn.formParams = {
        id: this.userId,
      };

      this.$store.dispatch("needUser", jsConn).then(() => {
        // correct user is in the store
        this.user = {
          name: this.apiUser.name,
          email: this.apiUser.email,
          id: this.apiUser.id,
          status: this.apiUser.status,
          password: "",
          permission_level: this.apiUser.permission_level,
        };
        this.dataLoaded = true;
        this.cancelParams = {
          name: "users",
        };
        this.$nextTick(() => this.$refs.firstInput.select());
      });
    }
  },
  methods: {
    submitForm(evt) {
      evt.preventDefault();
      const jsConn = new JSConn();
      let formParams;

      // remove the password if it is an empty string
      // if something gets changed and the password may be null, the check will
      // need to be changed also.
      // this allows for the admin changing things without changing the password
      if (this.user.password === "") {
        formParams = Rdissoc("password", this.user);
      } else {
        formParams = this.user;
      }

      jsConn.formParams = formParams;
      jsConn.toRoutePath = "/users";

      let storeDispatch;

      if (this.userId === "new") {
        storeDispatch = "createUser";
      } else {
        storeDispatch = "updateUser";
      }

      this.$store
        .dispatch(storeDispatch, jsConn)
        .then(jsConn => {
          this.$router.push(jsConn.toRoutePath);
          return Promise.resolve(jsConn);
        })
        .catch(jsConn => {
          this.hasFormErrors = true;
          this.formErrors = jsConn.error["response"]["data"];
        });
    },
    showDeleteModal() {
      this.$refs["deleteModal"].show();
    },
    hideDeleteModal() {
      this.$refs["deleteModal"].hide();
    },
    deleteUser() {
      const jsConn = new JSConn();
      jsConn.toRoutePath = "/users";
      jsConn.formParams = {
        id: this.userId,
      };
      this.$store.dispatch("deleteUser", jsConn).then(jsConn => {
        this.$router.push(jsConn.toRoutePath);
        return Promise.resolve(jsConn);
      });
    },
  },
  computed: {
    apiUser: function() {
      return this.$store.getters.user;
    },
  },
};
